import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "@/i18n/LanguageContext";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] },
  }),
};

export default function Contact() {
  const { t } = useI18n();

  return (
    <section
      id="contact"
      className="relative z-10 scroll-mt-24 border-t border-white/10 bg-[#050505] px-6 pt-32 pb-24 sm:pl-[120px] sm:pr-16"
      data-testid="contact-section"
    >
      <span className="font-mono-accent text-[11px] uppercase tracking-[0.3em] text-[#a855f7]">
        [ 04 — {t.sections.contact} ]
      </span>

      <motion.h2
        custom={0}
        variants={reveal}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-80px" }}
        className="mt-8 max-w-[16ch] font-head text-4xl font-light leading-[1.02] tracking-tight text-white sm:text-7xl"
      >
        {t.contact.headA}
        <span className="text-white/40"> {t.contact.headB}</span>
      </motion.h2>

      <div className="mt-16 grid grid-cols-1 gap-16 lg:grid-cols-2">
        <motion.div
          custom={1}
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
        >
          <p className="max-w-md font-body text-base leading-relaxed text-white/60">
            {t.contact.intro}
          </p>
          <a
            href="mailto:connect@orb-tech.co.uk"
            data-testid="contact-email"
            className="group mt-6 inline-flex items-center gap-3 font-head text-2xl font-light tracking-tight text-white transition-colors duration-300 hover:text-[#a855f7] sm:text-3xl"
          >
            connect@orb-tech.co.uk
            <ArrowUpRight className="h-6 w-6 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </motion.div>

        <motion.div
          custom={2}
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          data-testid="contact-address"
        >
          <p className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-white/30">
            {t.contact.registered}
          </p>
          <address className="mt-5 font-body text-base not-italic leading-relaxed text-white/60">
            Orb Holdings Limited
            <br />
            71–75 Shelton Street
            <br />
            Covent Garden
            <br />
            London WC2H 9JQ
            <br />
            England, United Kingdom
          </address>
        </motion.div>
      </div>
    </section>
  );
}
